import { get } from 'lodash-es';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { CarReviewsModel, getBestCategoryCarsPath } from 'client/data/models/car-reviews';
import { RandomModel, RandomPaths } from 'client/data/models/random';
import { getModelState } from 'client/data/luckdragon/model';
import { parseContent } from 'client/data/cms/content';
import { getMeta, getSeoImage } from 'site-modules/shared/utils/seo-helper';
import { setCriticalCss } from 'client/actions/critical-css';
import { EdmundsDefaultDecorator } from 'site-modules/shared/pages/decorators/edmunds-default';
import { RESEARCH_LINK_WIDGET_EDITORIAL_PATH } from 'site-modules/shared/constants/editorial/research-article';
import { CAR_REVIEW_CONTENT_FILE_PATH } from 'site-modules/car-reviews-landing/constants/car-reviews-landing';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { PageModel } from 'client/data/models/page';
import { CarReviewsPage } from './index';

export const pageDefinitionConfiguration = {
  name: 'car_reviews_index',
  category: 'car_reviews_index',
  seo: state => {
    const modelState = getModelState(state);
    const carReviewsContent = modelState.get(`content["${CAR_REVIEW_CONTENT_FILE_PATH}"]`, CmsModel);
    const content = parseContent(carReviewsContent);
    return { ...getMeta(content), image: getSeoImage(content) };
  },
  preload: async store => {
    const { featureFlags, mobile } = store.getState();
    const preloader = new ModelPreloader(store);
    preloader.resolve(`content["${CAR_REVIEW_CONTENT_FILE_PATH}"]`, CmsModel);
    preloader.resolve(getBestCategoryCarsPath(), CarReviewsModel);
    preloader.resolve(RandomPaths.getHeroImagePath('car_reviews_landing'), RandomModel);
    preloader.resolve(`content["${RESEARCH_LINK_WIDGET_EDITORIAL_PATH}"]`, CmsModel);

    store.dispatch(
      setCriticalCss({
        topRatedPromo: !!get(featureFlags, 'top-rated-promo'),
      })
    );

    const stateModel = await preloader.load();

    const heroImage = stateModel.get(RandomPaths.getHeroImagePath('car_reviews_landing'), RandomModel);
    preloader.set('server.preloadedAssets', PageModel, [
      {
        href: getStaticImageUrl(mobile ? get(heroImage, 'mobile') : get(heroImage, 'desktop')),
        as: 'image',
      },
    ]);

    return preloader.load();
  },
  component: CarReviewsPage,
  decorator: EdmundsDefaultDecorator,
};

export default pageDefinition(pageDefinitionConfiguration);
